import partner from './partner'

export default [...partner]
